angular.module('SpidApp')

.factory('Transaction', [function () {
	var Transaction = function (params) {
		params = params || {}
		
		this.id         = params.id
		this.vacationId = params.vacation_id
		this.bill       = params.bill
		this.finished   = !!params.finished
		this.username   = params.username
		this.agency_id  = params.agency_id
		this.updatedAt  = params.updated_at
	}

	Transaction.prototype.setFinished = function () {
		this.finished = true
	}

	return Transaction
}])